export const translations = {
  de: {
    header: {
      cta: 'Weiter',
      navTraining: 'Training',
      navErnaehrung: 'Ernährung',
      navAbo: 'Abo',
    },
    hero: {
      badge: 'KI-gestütztes Training mit Lazar Angelov',
      line1: 'WILLKOMMEN',
      line2: 'IN DER WELT',
      line3: 'DER SESSIONS',
      title: 'Willkommen in der Welt der Training-Sessions',
      sub: 'Mit Fitupkeep erhalten Sie ein individuelles, KI-gestütztes Trainingsprogramm, unterstützt von Lazar Angelov, das Sie ganz nach Ihren persönlichen Zielen und Bedürfnissen zusammenstellen können. Das Programm eignet sich sowohl für Einsteiger als auch für fortgeschrittene Sportler. Dank der leistungsstarken KI umfasst das Angebot zudem einen detaillierten und ausgewogenen Ernährungsplan mit einer Vielzahl an Rezepten, abgestimmt auf unterschiedliche Ernährungsformen, egal ob vegan, vegetarisch oder omnivor.',
      price: 'Das Abonnement kostet 5 Euro pro Woche (inkl. MwSt).',
      cta: 'Weiter',
      consent:
        'Mit der Bestätigung der Schaltfläche „Weiter“ stimmen Sie den Allgemeinen Geschäftsbedingungen zu. Die Abrechnung erfolgt bequem über Ihre Mobilfunkrechnung.',
      stats: [
        { value: 'KI', label: 'Individuelles Trainingsprogramm' },
        { value: '5 €', label: 'pro Woche inkl. MwSt.' },
        { value: '24/7', label: 'Zugang zu den Sessions' },
      ],
      chat: [
        { from: 'user', text: 'Welche Session passt heute zu meinem Ziel?' },
        {
          from: 'ai',
          text: 'Basierend auf Ihrem Plan starte ich eine 28-Minuten Oberkörper-Session. Soll ich den Ernährungsplan dazu anpassen?',
        },
        { from: 'user', text: 'Ja, bitte vegan.' },
      ],
      recipeCard: {
        tag: 'KI-Ernährungsplan',
        title: 'Proteinbowl, vegan',
        kcal: '480 kcal',
        protein: '34 g Protein',
        time: '18 min',
      },
      floating: [
        { title: 'Neue Session bereit', value: 'Brust und Trizeps, 28 min' },
        { title: 'Ernährungsform', value: 'Vegan, vegetarisch oder omnivor' },
      ],
    },
    ticker: [
      'Individuelle Training-Sessions',
      'KI-gestütztes Programm',
      'Unterstützt von Lazar Angelov',
      'Ernährungsplan mit Rezepten',
      'Vegan, vegetarisch oder omnivor',
      'Für Einsteiger und Profis',
    ],
    problems: {
      kicker: 'Ihre Ziele',
      title: 'Ein Programm, das sich an Sie anpasst, nicht umgekehrt',
      sub: 'Fitupkeep verbindet Training und Ernährung in einem Abonnement, das Sie über Ihre Mobilfunkrechnung nutzen.',
      items: [
        {
          title: 'Individuell statt Standard',
          desc: 'Stellen Sie Ihr KI-gestütztes Trainingsprogramm nach persönlichen Zielen und Bedürfnissen zusammen.',
        },
        {
          title: 'Für jedes Niveau',
          desc: 'Das Programm eignet sich sowohl für Einsteiger als auch für fortgeschrittene Sportler.',
        },
        {
          title: 'Training plus Ernährung',
          desc: 'Zu den Sessions kommt ein detaillierter, ausgewogener Ernährungsplan mit vielen Rezepten.',
        },
        {
          title: 'Einfache Abrechnung',
          desc: '5 Euro pro Woche inkl. MwSt., bequem über Ihre Mobilfunkrechnung. Jederzeit kündbar.',
        },
      ],
    },
    platform: {
      kicker: 'Das Programm',
      title: 'Training-Sessions, die zu Ihrem Alltag passen',
      sub: 'Mit jeder Session können Sie eine Muskelgruppe trainieren. Egal, ob Amateur oder Profi: bleiben Sie immer fit. Fitupkeep gewährt Ihnen laufenden Zugang zu den neuesten Training-Sessions.',
      coachTitle: 'Unterstützt von Lazar Angelov',
      coachDesc:
        'Ihr individuelles, KI-gestütztes Trainingsprogramm wird von Lazar Angelov unterstützt. Sie stellen es nach Ihren Zielen zusammen und trainieren Session für Session.',
      coachPill: 'Einsteiger und Fortgeschrittene',
      items: [
        {
          title: 'KI-Trainingsplan',
          desc: 'Ein individuelles Programm, das sich an Ihren Zielen und Bedürfnissen orientiert.',
        },
        {
          title: 'Session pro Muskelgruppe',
          desc: 'Mit jeder Session trainieren Sie gezielt eine Muskelgruppe.',
        },
        {
          title: 'Für jedes Level',
          desc: 'Vom ersten Workout bis zum ambitionierten Training.',
        },
        {
          title: 'Videobasierte Sessions',
          desc: 'Die neuesten Training-Sessions, bereit zum Starten.',
        },
        {
          title: 'Ziele statt Zufall',
          desc: 'Sie entscheiden, worauf Sie sich konzentrieren möchten.',
        },
        {
          title: 'Immer verfügbar',
          desc: 'Zugang über Mobilgerät, Android, iPhone, Windows sowie PC und Mac.',
        },
      ],
    },
    nutrition: {
      kicker: 'Ernährungsplan',
      title: 'Ausgewogen essen, passend zu Ihrer Ernährungsform',
      sub: 'Die KI erstellt einen detaillierten und ausgewogenen Ernährungsplan mit einer Vielzahl an Rezepten, abgestimmt auf vegan, vegetarisch oder omnivor.',
      features: [
        'Detaillierter Ernährungsplan',
        'Ausgewogene Makros',
        'Rezepte für den Alltag',
        'Vegan, vegetarisch oder omnivor',
        'Abgestimmt auf Ihre Sessions',
      ],
      calculatorTitle: 'Abgestimmt auf Sie',
      calculatorSub: 'Der Plan berücksichtigt unter anderem:',
      calculatorInputs: ['Ziele', 'Niveau', 'Ernährungsform', 'Alltag', 'Sessions', 'Bedürfnisse'],
      macros: [
        { label: 'Protein', pct: 35 },
        { label: 'Kohlenhydrate', pct: 40 },
        { label: 'Fett', pct: 25 },
      ],
      dailyGoal: 'Beispielverteilung',
    },
    recipes: {
      kicker: 'Rezepte',
      title: 'Viele Rezepte, eine Richtung: Ihre Ziele',
      sub: 'Ob vegan, vegetarisch oder omnivor: der Ernährungsplan liefert passende Rezepte zu Ihrem Training.',
      libraryTitle: 'Rezeptvielfalt',
      library: [
        'Rezepte für vegane Ernährung',
        'Vegetarische Alltagsgerichte',
        'Omnivore Protein-Gerichte',
        'Abgestimmt auf den Trainingsplan',
      ],
      outputTitle: 'Jeder Plan kann enthalten',
      output: [
        'Kalorien',
        'Protein, Kohlenhydrate und Fett',
        'Portionsgrößen',
        'Zutatenlisten',
        'Zubereitungszeit',
        'Passende Sessions',
      ],
    },
    grocery: {
      kicker: 'So funktioniert es',
      title: 'In wenigen Schritten zu Ihren Sessions',
      sub: 'Sie wählen das Abonnement, bestätigen den Kauf und erhalten Zugang zum Produkt. Die Abrechnung läuft über Ihre Mobilfunkrechnung.',
      steps: [
        'Sie landen auf der Startseite und bestätigen, dass Sie den Dienst abonnieren möchten.',
        'Auf der nächsten Seite bestätigen Sie das Abonnement mit Weiter.',
        'Mit „Weiter“ stimmen Sie den Allgemeinen Geschäftsbedingungen zu.',
        'Danach werden Sie zur Bezahlbestätigung und zum Produkt weitergeleitet.',
        'Sie erhalten Zugang zu Training-Sessions und Ernährungsplan.',
        'Das Abonnement kostet 5 Euro pro Woche inkl. MwSt. und verlängert sich, bis Sie kündigen.',
      ],
    },
    vision: {
      kicker: 'Fitupkeep',
      title: 'Die neuesten Training-Sessions. Immer fit bleiben.',
      statement:
        'Mit jeder Session können Sie eine Muskelgruppe trainieren. Egal, ob Amateur oder Profi: bleiben Sie immer fit.',
      cards: [
        {
          title: 'Wöchentliches Abo',
          desc: '5 Euro pro Woche inkl. MwSt. Abrechnung über die Mobilfunkrechnung.',
        },
        {
          title: 'Jederzeit kündbar',
          desc: 'Kündigung über die Hotline 080010029, per E-Mail oder über die Abo Verwaltung.',
        },
        {
          title: 'Kundenservice in Österreich',
          desc: 'dailyfit24.at@silverlines.info und telefonisch unter 080010029.',
        },
      ],
    },
    cta: {
      title: 'Bereit für Ihre nächste Session?',
      sub: 'Starten Sie Fitupkeep. 5 Euro pro Woche inkl. MwSt.',
      button: 'Weiter',
      note: 'Mit „Weiter“ stimmen Sie den AGB zu. Abrechnung über die Mobilfunkrechnung.',
    },
    form: {
      cta: 'Weiter',
      consent:
        'Mit der Bestätigung der Schaltfläche „Weiter“ stimmen Sie den Allgemeinen Geschäftsbedingungen zu. Die Abrechnung erfolgt bequem über Ihre Mobilfunkrechnung.',
    },
    footer: {
      blurb:
        'Fitupkeep: die neuesten Training-Sessions. Mit jeder Session können Sie eine Muskelgruppe trainieren. Egal, ob Amateur oder Profi: bleiben Sie immer fit. Fitupkeep Dienst: Das Abonnement kostet 5 Euro pro Woche (inkl. MwSt). Die Abrechnung erfolgt über die Mobilfunkrechnung. Mit der Bestätigung der Schaltfläche „Weiter“ stimmen Sie den Allgemeinen Geschäftsbedingungen zu. Diensteanbieter: MBX Productive Ltd. Kundenservice: dailyfit24.at@silverlines.info, Telefon 080010029.',
      links: [
        { label: 'AGB', href: '/agb.html' },
        { label: 'Impressum', href: '/impressum.html' },
        { label: 'Kontakt & Hilfe', href: '/hilfe.html' },
        { label: 'Abo Verwaltung', href: '/abo.html' },
        { label: 'Nutzungsbedingungen', href: '/nutzungsbedingungen.html' },
        { label: 'Rücktrittsrecht', href: '/ruecktritt.html' },
      ],
      contactTitle: 'Kundenservice',
      company: 'MBX Productive Ltd',
      address: 'Pimen Zogravski Nr. 14, 1000 Sofia, Bulgaria',
      email: 'dailyfit24.at@silverlines.info',
      phone: '080010029',
      copyright: 'Copyright 2026 Fitupkeep. Alle Rechte vorbehalten.',
    },
  },
};
